if (!customElements.get('sd-equipment-specs')) {
  customElements.define('sd-equipment-specs', class extends HTMLElement {
    connectedCallback() {
      this.onVariantChange = async (event) => {
        if (!event.detail?.variant?.id || !event.detail.formId?.includes(this.dataset.productId)) return;
        this.controller?.abort();
        const controller = this.controller = new AbortController();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', event.detail.variant.id);
        url.searchParams.set('sections', this.dataset.sectionId);
        try {
          const response = await fetch(url, {signal: controller.signal, headers: {Accept: 'application/json'}});
          if (!response.ok) return;
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (!html || controller.signal.aborted) return;
          const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('sd-equipment-specs');
          if (replacement) this.replaceWith(replacement);
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.refreshFailed = 'true';
        }
      };
      document.addEventListener('variant:changed', this.onVariantChange);
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.removeEventListener('variant:changed', this.onVariantChange);
    }
  });
}
